<div class="dropdown dropdown-hover nav-profile standalone-widget">
  <!-- Login / Profile dropdown in navbar -->
  <a
    [href]="profileUrl"
    appUnsavedFormCheck
    class="navigation__profile-user d-lg-block text-decoration-none"
  >
    <div
      *ngIf="!sessionService.authenticated; else profileLink"
      class="nav-link text-center"
    >
      <a
        appRequireLogin
        class="d-flex flex-md-column align-items-center"
      >
        <img
          class="rounded-circle nav-profile__avatar"
          appDefaultAvatar
          alt="user-avatar"
        />
      </a>

      <span
        class="nav-login__dropdown dropdown-toggle"
        id="dropdownMenuLogin"
      >
        {{ 'Login' | translate }}
      </span>
    </div>

    <ng-template #profileLink>
      <div class="nav-link text-center">
        <ng-container *ngTemplateOutlet="profileAvatarRef"></ng-container>

        <span class="nav-profile__dropdown dropdown-toggle standalone-widget">
          {{ 'Profile' | translate }}
        </span>
      </div>
    </ng-template>
  </a>

  <!-- Dropdown -->
  <div
    class="nav-profile__dropdown-menu dropdown-menu standalone-widget dropdown px-0"
    aria-labelledby="dropdownMenuButton"
  >
    <!-- Logged-in user info -->
    <section
      class="nav-profile d-block d-lg-block"
      *ngIf="profile && sessionService.authenticated"
    >
      <div class="navigation__content--padding">
        <div class="d-flex">
          <div class="d-flex align-items-center">
            @let alt = profile?.image?.alt || 'User avatar';

            <img
              [src]="profile?.image?.url || profile?.image"
              appDefaultAvatar
              [alt]="alt"
              [ngbTooltip]="
                profile?.image?.title ||
                ('Profile.Default.MyProfileImage' | translate)
              "
              container="body"
              class="rounded-circle nav-profile__avatar nav-profile__avatar--small"
            />
          </div>

          <ul class="nav-profile__text ps-0 mb-0 list-unstyled">
            <li class="nav-profile__name text-truncate fw-bold">
              {{ profile.firstName }} {{ profile.lastName }}
            </li>

            <li class="text-truncate">
              {{ profile.email }}
            </li>

            <li class="text-truncate">
              {{ profile.phone }}
            </li>

            <li class="text-truncate">
              {{ profile.company?.name || profile.company }}
            </li>
          </ul>
        </div>

        <a
          appUnsavedFormCheck
          [href]="profileUrl"
          class="btn btn-outline-primary w-100 py-0 mt-2 text-decoration-none"
          translate
        >
          <ng-icon name="matPerson"></ng-icon>
          My Profile
        </a>
      </div>

      <ng-container *ngTemplateOutlet="profileActions"></ng-container>

      <ng-container *ngTemplateOutlet="appInformationRef"></ng-container>

      <ng-container *ngTemplateOutlet="loginLogoutRef"></ng-container>
    </section>
  </div>

  <div
    class="dropdown-menu dropdown px-0"
    aria-labelledby="dropdownMenuLogin"
  >
    <section
      class="nav-profile d-lg-block"
      aria-labelledby="dropdownMenuLink"
      *ngIf="!sessionService.authenticated"
    >
      <ng-container *ngTemplateOutlet="appInformationRef"></ng-container>

      <ng-template [ngTemplateOutlet]="loginRef"></ng-template>
    </section>
  </div>
</div>

<ng-template #profileActions>
  <ng-container *ngIf="sessionService.authenticated">
    <div class="navigation__content--padding text-center">
      <div
        class="nav-profile__action-item fw-bold"
        translate
      >
        UI.Nav-Profile.Account
      </div>

      <div class="nav-profile__action-item">
        <a
          appRequireLogin
          appUnsavedFormCheck
          (click)="storePreviousUrl()"
          [href]="changePasswordUrl"
          class="nav-link p-0"
        >
          {{ 'ChangePassword' | translate }}
        </a>
      </div>

      <div class="nav-profile__action-item">
        <a
          appRequireLogin
          appUnsavedFormCheck
          (click)="storePreviousUrl()"
          [href]="changeEmailUrl"
          class="nav-link p-0"
        >
          {{ 'UI.Nav-Profile.Change-email' | translate }}
        </a>
      </div>
    </div>
  </ng-container>
</ng-template>

<ng-template #appInformationRef>
  <app-nav-information
    [navigateUrl]="about_link"
    [isTenantAdmin]="profile?.isTenantAdmin"
    isStandaloneWidget="true"
  ></app-nav-information>
</ng-template>

<ng-template #profileAvatarRef>
  <a
    [href]="profileUrl"
    appUnsavedFormCheck
    class="d-flex flex-md-column align-items-center text-center justify-content-center"
  >
    @let alt = profile?.image?.alt || 'User avatar';

    <img
      [src]="profile?.image?.url || profile?.image"
      class="rounded-circle nav-profile__avatar"
      appDefaultAvatar
      [alt]="alt"
      [ngbTooltip]="
        profile?.image?.title || ('Profile.Default.MyProfileImage' | translate)
      "
      container="body"
    />
  </a>
</ng-template>

<ng-template #loginRef>
  <div class="nav-profile__action-item nav-profile__action-item--logout p-0">
    <button
      class="btn-unstyled w-100 p-2"
      (click)="goToLoginPage()"
      appRequireLogin
      translate
    >
      Login
    </button>
  </div>
</ng-template>

<ng-template #loginLogoutRef>
  <div
    *ngIf="sessionService.authenticated; else loginRef"
    appUnsavedFormCheck
    (clickAfterChecking)="logout($event)"
    class="nav-profile__action-item navigation__content--padding desktop-link nav-link text-center"
    translate
  >
    @if (!isMobile) {
      <ng-icon
        name="matLogoutOutline"
        class="fs-6"
      ></ng-icon>
    }

    Log out
  </div>
</ng-template>
